export default "__VITE_ASSET__BoiVNzmf__"